<template>
  <div class="friend-parent">
    <div class="friend-picture">
      <img :src="friend.avatarfull" />
      <div class="overlay" @click="addFriend">
        <div class="text">
          <span class="icon is-small is-left">
            <i class="fas fa-plus" />
          </span>
        </div>
      </div>
    </div>
    <p>{{ friend.personaname }}</p>
  </div>
</template>

<script>
export default {
  name: "Friend",
  props: {
    friend: {
      type: Object,
      default: null,
    },
  },
  methods: {
    addFriend: function () {
      this.$emit("addFriend", this.friend);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.friend-parent {
  margin-bottom: 1em;
  margin-right: 1em;
}
.friend-picture {
  display: flex;
}

.text {
  font-size: 40px;
  text-align: center;
  line-height: 100px;
  opacity: 0.5;
}

.friend-picture:hover .overlay {
  opacity: 1;
  cursor: pointer;
}

.friend-parent img {
  height: 80px;
  width: 80px;
}
.friend-parent p {
  font-size: 14px;
  font-weight: 200;
  overflow: hidden;
  max-width: 80px;
  text-overflow: ellipsis;
}

.overlay {
  position: absolute;
  width: 80px;
  height: 80px;
  opacity: 0;
  transition: 0.5s ease;
  background-color: white;
}
</style>